<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="地址信息" size="60%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="btt"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
               style="margin-left: 150px;"
    >
      <!-- 品牌信息 -->
      <div class="detail-wrap">

        <el-row></el-row>
        <el-row>
          <el-col :span="24">
            <vxe-table
              style="margin-top: 0px; height: 80%"
              :stripe="true"
              ref="vxeTable"
              height="320"
              :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
              :row-config="{height: 30,isHover: true,padding: 0,}"
              :row-style="{ fontSize: '12px',  }"
              show-overflow
              :column-config="{ resizable: true }"
              @checkbox-change="selectChangeEvent"
              @checkbox-all="selectChangeEvent"
              @radio-change="({row}) => {selectedData = row}"
              :data="addressList">
              <vxe-column type="radio" width="40"/>
              <vxe-column field="addressTypeName" title="地址类型" width="120"></vxe-column>
              <vxe-column field="addressMan" title="联系人" width="120"></vxe-column>
              <vxe-column field="addressMobile" title="联系人电话" width="120"></vxe-column>
              <vxe-column field="" title="地区" width="300">
                <template #default="{row}">
                  <span>{{row.province}}{{row.city}}{{row.county}}{{row.town}}</span>
                </template>
              </vxe-column>
              <vxe-column field="address" title="详细地址" width="300"></vxe-column>
<!--              <vxe-column field="outWarehouse" title="实际发货仓" width="130">-->
<!--                <template #default="{row}" style="width: 100px;">-->
<!--                  <el-select v-if="row.changeWarehouse" v-model="row.outWarehouseId"  style="width: 100px;" @change="outWarehouseChange(row)">-->
<!--                    <el-option v-for="item in warehouseList"-->
<!--                               :key="item.id"-->
<!--                               :label="item.warehouseName"-->
<!--                               :value="item.id"-->
<!--                    />-->
<!--                  </el-select>-->
<!--                  <span v-else>&nbsp;&nbsp;{{ row.outWarehouseName }}</span>-->
<!--                </template>-->
<!--              </vxe-column>-->

            </vxe-table>
          </el-col>
        </el-row>

      </div>

      <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
        <!--        <el-button @click="dialogClose">取 消</el-button>-->
        <el-button type="primary" @click="commitRow">
          确 定
        </el-button>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  name: 'siteAddressDialog',
  props: ['visiable', 'multi', 'siteId'],
  components: {},
  mounted() {

  },
  data() {
    return {
      drawer: false,

      shippingMethodList: [],
      showEdit: false,

      formData: {
        id: null,
        orgId: null,
        outWarehouse: null,
        deliverType: null,
        outType: null,
        spPartsApplyLineDTOList: [],
      },
      warehouseList: [],
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,

      selectedData: null,

      addressList: [],
    };
  },

  methods: {
    loadSiteAreaData() {
      this.$mask.open()
      this.$http.post(api.snUser.getSiteAddressListUrl, {id: this.siteId}).then(res => {
        this.addressList = res.data.data
        this.$mask.close()
      })
    },

    commitRow() {
      this.$emit('commitRow', this.selectedData)
      this.drawer = false
    },

    dialogShow() {
      if (!this.siteId) {
        this.$message.error('请先选中网点')
        return
      }

      this.drawer = true;
      this.loadSiteAreaData()
    },
    dialogClose() {
      this.drawer = false;
      this.$emit('update:visiable', this.drawer)
    },
    // 关闭
    confirm() {

      this.handleClose()
    },
    cancelForm() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    },
    handleClose(done) {
      // this.cancelForm()

      this.$confirm('确认关闭？')
        .then(_ => {
          done();
          this.cancelForm()
        })
        .catch(_ => {
        });

    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}


.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


// .d-item {
//   border: 1px solid #ededed;
// }

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

// ::v-deep tbody tr td .el-input {
//   width: 100% !important;
//   width: 165px !important;
// }

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
// ::v-deep .el-select .el-input.is-focus .el-input__inner {
//     width: 90px;
// }
</style>
